import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold text-white mb-4">
              <span className="text-green-500">V&D Storage</span>
              <span className="text-white"> Streetman</span>
            </div>
            <p className="text-gray-400 mb-4">
              Secure, affordable, and convenient self-storage solutions for boats, RVs, and household items.
              Your belongings, our priority.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-green-500 transition-colors" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-green-500 transition-colors" aria-label="Twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-green-500 transition-colors" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-green-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/enclosed-boat-rv-storage-streetman" className="hover:text-green-500 transition-colors">
                  Enclosed Boat & RV
                </Link>
              </li>
              <li>
                <Link to="/household-business-storage-streetman" className="hover:text-green-500 transition-colors">
                  Household & Business
                </Link>
              </li>
              <li>
                <Link to="/size-guide" className="hover:text-green-500 transition-colors">
                  Size Guide
                </Link>
              </li>
              <li>
                <Link to="/tips-rules" className="hover:text-green-500 transition-colors">
                  Tips & Rules
                </Link>
              </li>
              <li>
                <Link to="/tenant-protection" className="hover:text-green-500 transition-colors">
                  Tenant Protection
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-green-500 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-green-500 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Phone className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
                <a
                  href="tel:8007687640"
                  onClick={() => {
                    if (window.gtag) {
                      window.gtag('event', 'conversion_intent', {
                        'event_category': 'lead',
                        'event_label': 'footer_phone_call',
                        'facility_name': 'VD Storage Streetman'
                      });
                    }
                  }}
                  className="hover:text-green-500 transition-colors"
                >
                  (800) 768-7640
                </a>
              </li>
              <li className="flex items-start">
                <Mail className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
                <span>info@vdstoragestreetman.com</span>
              </li>
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
                <span>543 FM 416<br />Streetman, TX 75859</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} V&D Storage. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;